import { configureStore } from "@reduxjs/toolkit";
import rootReducers from "@/redux/reducers"; // Import root reducers
import loggerMiddleware from "@/redux/middleware/logger";

const createStore = (preloadedState?: any) => {
  const store = configureStore({
    reducer: rootReducers,
    preloadedState,
  });

  // @ts-ignore
  if (process.env.NODE_ENV !== "production" && module.hot) {
    // @ts-ignore
    module.hot.accept("./reducers", () => store.replaceReducer(rootReducers));
  }

  return store;
};

export type AppStore = ReturnType<typeof createStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];

export default createStore;
